export default {
  "ALLTYPES": "所有类型",
  "AccountHierarchySettings": {
    "account": "账号",
    "dialogTitle": "{t}员工上下级关系",
    "directSuperiorAccount": "直接上级账号",
    "directSuperiorEmail": "直接上级邮箱",
    "directSuperiorName": "直接上级名称 ",
    "email": "邮箱",
    "employeeAccount": "员工账号",
    "employeeName": "员工名称",
    "isThereASkipLevelLeader": "是否有跨级领导",
    "name": "名称",
    "no": "无",
    "searchPlaceholder": "请输入员工名称、直接上级名称、跨级领导名称",
    "skipLevelLeaderAccount": "跨级领导账号",
    "skipLevelLeaderEmail": "跨级领导邮箱",
    "skipLevelLeaderName": "跨级领导名称",
    "yes": "有"
  },
  "AddCover": "添加面料",
  "AddData": "添加数据",
  "AddVideo": "添加视频/图片",
  "AddtoEmail": "添加邮件",
  "Admin": {
    "AP": "活跃占比",
    "AllocateAmount": "分配金额",
    "ArchitectureArea": "架构区域",
    "BWC": "企微ID",
    "ManufacturingPlant": "发货工厂",
    "NOL": "登录人数",
    "OFTHEDIV": "所属事业部",
    "OTF": "架构所属",
    "PONo": "PI号",
    "POSettlement": "PI结算",
    "POType": "PI类型",
    "SAPPI": "SAP单号",
    "SAPStatus": "SAP状态",
    "TL": "总账户数",
    "account": "账户",
    "active": "激活",
    "add": "添加",
    "addAccount": "创建账户",
    "addOnOption": "添加选购",
    "addOnOption1": "加入选购清单",
    "addRelationship": "新增离职与继承关系",
    "addtoPo": "添加到PI",
    "all": "全部",
    "amountSum": "金额小计",
    "amountTotal": "金额合计",
    "ariA": "离职人员数据继承",
    "arms": "扶手",
    "arrangementType": "组合类别",
    "authorizedSignature": "客户签名",
    "backs": "靠背",
    "bd": "所属事业部",
    "businessEmail": "业务邮箱",
    "buyer": "联系人",
    "cabinetType": "柜型",
    "cancel": "取消",
    "categories": "类别",
    "category": "类别",
    "checkAll": "全选",
    "china": "中国",
    "chinavietnam": "中国或越南",
    "cis": "是否能发送SAP",
    "clear": "清空",
    "closeAll": "关闭所有",
    "closeOther": "关闭其他",
    "closing": "关闭",
    "code": "编码",
    "color": "颜色",
    "completeSetNumber": "整套编号",
    "component": "成分",
    "confirm": "确定",
    "confirmDelete": "确认删除？",
    "confirmInheritanceMessage": "是否确定继承？一旦确认，改操纵无法撤销",
    "container": "货柜",
    "containerCaculation": "算柜结算",
    "containerVolumeUtilizationRate": "货柜体积使用率",
    "content": "成分",
    "continue": "是否继续",
    "copy": "复制",
    "coverGrade": "颜色等级",
    "createdAccount": "账户管理",
    "cube": "材积",
    "cubeSum": "材积小计",
    "cubeTotal": "材积合计",
    "cubes": "体积",
    "cubesTotal": "体积合计",
    "customerEmail": "客户邮箱",
    "customized": "定制",
    "deleteInfo": "此操作将永久删除该数据, 是否继续?",
    "depth": "坐深",
    "description": "描述",
    "disable": "注销",
    "discountAmount": "折扣金额",
    "discountRate": "折扣率",
    "edit": "编辑",
    "editAccount": "编辑账户",
    "effective": "有效",
    "email": "邮箱",
    "emailEnter": "多个邮箱请用英文分号隔开",
    "emailStatus": "邮件状态",
    "enable": "启用",
    "errorInfo": "删除失败",
    "exportPO": "导出PI",
    "failToSend": "发送失败",
    "fax": "传真",
    "features": "产品特点",
    "fp": "离职人",
    "freight": "运费",
    "grade": "等级",
    "group": "组别",
    "height": "高度",
    "image": "图片",
    "inactive": "未激活",
    "index": "序号",
    "inheritor": "继承人",
    "isUsed": "启用",
    "leading": "主推",
    "leather": "皮",
    "length": "长度",
    "loadability": "装柜量",
    "loginlog": "登录日志",
    "lwh": "产品尺寸 长*宽*高 (in)",
    "marketModel": "展会款",
    "marketNewModel": "展会新款",
    "material": "物料",
    "mechanisms": "功能铁架",
    "mes1": "（注意：继承人将继承离职人的展会客户信息，竞品信息，上下级关系等，一旦操作数据不可撤销）",
    "mexico": "墨西哥",
    "models": "款式",
    "motion": "功能",
    "motionType": "功能类别",
    "name": "名称",
    "nationality": "国籍",
    "networkError": "网络错误",
    "no": "否",
    "notSigned": "您还没有签名，确定提交吗？",
    "offShelf": "下架",
    "op": "操作人",
    "ot": "操作时间",
    "package": "包装",
    "packageMethod": "包装方式",
    "packageSize": "包装尺寸 长*宽*高 (in)",
    "params": "参数",
    "pieceCount": "件数",
    "pleaseEnter": "请填写",
    "pleaseEnterQTY": "请输入数量",
    "pleaseSelect": "请选择",
    "pleaseSelectAvaliablePO": "勾选的数据必须全部有效",
    "pleaseSelectPO": "请勾选要操作的数据",
    "poNo": "PI号",
    "position": "职位",
    "price": "价格",
    "priceRange": "价格区间",
    "promptInfo": "材积已到2200",
    "provenance": "产地",
    "pts": "你只能选中单个PI复制！",
    "qsInventoryAddCarError": "未存在可下单款式列表，请联系管理员更新",
    "quantityOfGoods": "货物数量",
    "rai": "离职继承",
    "readyDate": "客户要求交期",
    "relevantP": "相关人员",
    "role": "角色",
    "salesDiscount": "销售折扣",
    "salesPrice": "销售价",
    "save": "保存",
    "seats": "座位数",
    "seats2": "座包",
    "selectiveColor": "可选颜色",
    "sendEmail": "发送邮件",
    "sendPo": "复制PI",
    "sendToSap": "发送SAP",
    "sent": "已发送",
    "sentSuccessfully": "发送成功",
    "sentence": "不一致，无法创建",
    "setQuantity": "成套数量",
    "settingUp": "创建",
    "settlementPO": "结算PI",
    "settlementPOTips": "该PI订单已算柜",
    "signatureVerification": "签名确认",
    "skin": "皮",
    "skuType": "SKU类别",
    "spec": "规格",
    "status": "状态",
    "styles": "风格",
    "subtotal": "合计",
    "tips": "提示",
    "total": "合计",
    "totalCargoVolume": "合计货物体积",
    "totalOrderAmount": "订单金额合计",
    "trait": "特性",
    "type": "类别",
    "uniqueArrangment": "唯一规格",
    "unit": "单位",
    "update": "修改",
    "userAccount": "用户账户",
    "userCode": "工号",
    "vietnam": "越南",
    "view": "预览",
    "weight": "重量",
    "width": "宽度",
    "yes": "是"
  },
  "AmountIsNotANumber": "金额不是数字",
  "BatchImport": "批量导入",
  "Brand": "品牌",
  "CatalogPages": "目录页",
  "ClientName": "客户名称",
  "Closeup": "特殊的",
  "Commitments": {
    "AddExReservation": "新增展会预约",
    "AddMarket": "新增展会",
    "AddNewCustomerData": "新增客户数据添加",
    "AnnualTurnover": "年度营业额",
    "ArrangementMaintainTemplate": "规格维护模板",
    "Arrangements": "布局",
    "BonusMonth": "奖励月份",
    "Color": "颜色",
    "CommitmentConfirm": "意向订单确认",
    "CommitmentQTY": "意向订单柜数",
    "CommitmentsList": "意向清单",
    "Company": "客户名称",
    "Confirm": "认证",
    "ConfirmedOrderAMT": "确认订单金额",
    "ConfirmedOrderQTY": "确认订单柜数",
    "Country": "国家/地区",
    "Covers": "封面",
    "Customer": "负责人",
    "CustomerConfirmedDate": "确认日期",
    "CustomerName": "客户名称",
    "CustomerType": "客户类型",
    "CustomersToInvite": "需邀约客户数",
    "DescCombination": "规格组合",
    "Describe": "描述",
    "Division": "事业部",
    "Edit": "操作",
    "Email": "联系方式",
    "ExhibitionBonusDistributionTemplate": "展会奖金分配模板",
    "ExhibitionBonusStylesTemplate": "展会奖金款式模板",
    "IMIC": "展会邀请客户信息",
    "IMICT": "展会邀请客户信息模板",
    "LineItemNumber": "行项目号",
    "MaintainTemplate": "新款维护模板",
    "Maintainer": "维护人",
    "MaintenanceDate": "维护日期",
    "Market": "展会",
    "MarketNameCN": "展会名称-中文",
    "MarketNameEN": "展会名称-英文",
    "MarketTime": "预约到展会时间",
    "MarketsEndDate": "展会结束时间",
    "MarketsList": "展会",
    "MarketsName": "展会名称",
    "MarketsStartDate": "展会开始时间",
    "MaterialCode": "物料编码",
    "MaterialNumber": "物料号",
    "Nationality": "业务国家/地区",
    "NewCustomer": "新客户",
    "NewCustomers": "新客户数",
    "NewModelLaunchDate": "新款上线时间",
    "NewModelOrigin": "新款来源",
    "NewReGularCustomer": "新/老客户",
    "NumberOfOrders": "订单数量",
    "OldModelReExhibit": "是否老款重展",
    "OrderAmount": "订单金额",
    "OrderCutofftime": "订单截止日期",
    "OrderPlaceDate": "下单日期",
    "OverdueDays": "逾期天数",
    "PODate": "确认订单日期",
    "POOrderNumber": "PO单号",
    "ReasonForNotOrdering": "未下单原因",
    "RegularCustomers": "老客户数",
    "RequestedReadyDate": "出货日期",
    "Sales": "Sales",
    "SalesDepartment": "销售部门",
    "ShippingCutoffTime": "出货截止日期",
    "StartDate": "开始时间",
    "StoreNumber": "门店数量",
    "StyleSpecifications": "款式规格",
    "Title": "职位",
    "TotalAmount": "总金额",
    "VPSales": "VP/Sales",
    "ViaitingTimeLately": "上次拜访客户时间",
    "actualFactoryDate": "实际访厂日期",
    "actualVisitMarketTime": "实际到展时间",
    "addAppointment": "添加展会预约客户",
    "agree": "通过",
    "appointmentApprovalProcess": "预约审批流程",
    "appointmentList": "预约列表",
    "approval": "审核",
    "approvalComments": "审批意见",
    "approvalList": "审批列表",
    "approvalStatus": "审批状态",
    "approved": "审批通过",
    "approverComments": "负责人审批意见",
    "area": "区域",
    "clientsToInvite": "邀约客户数",
    "companyName": "公司名称",
    "countryState": "国家/地区",
    "countryStates": "客户国家/地区",
    "create": "创建",
    "detail": "明细",
    "endDate": "结束时间",
    "exhibitionCalendar": "展会日历",
    "exhibitionDepartment": "参展事业部",
    "expectedFactoryDate": "预计访厂日期",
    "exportMes": "导出产品信息",
    "footerTips": "已经到底啦",
    "generalManagerApproval": "总经理审批意见",
    "hasBeenInvited": "已邀约",
    "id": "序号",
    "mUnit": "Unit M($)",
    "marketArrivialConfirm": "确认到展",
    "marketRanking": "市场排名",
    "meetingContent": "会议内容",
    "mwSales": "敏华生意额",
    "nationalitys": "VP/Sales国籍",
    "nextClientVisitDate": "下次客户拜访日期",
    "officeExport": "出口办导出",
    "online": "电商",
    "partyAttendanceNum": "派对出席人数",
    "pendingApproval": "待审批",
    "pendingReview": "待审核",
    "pendingSubmission": "待提交",
    "percentage": "敏华生意额占比",
    "quantity": "数量",
    "recall": "撤回",
    "reject": "驳回上一级",
    "reject1": "驳回给业务",
    "rejected": "已驳回",
    "remark": "备注",
    "retailer": "零售商",
    "reviewComments": "审核意见",
    "saleDeptInp": "请输入销售部门",
    "selectCountry": "请选择国家",
    "selectCustomerName": "请选择客户名称",
    "sofaSales": "大约沙发生意额",
    "state": "州",
    "status": "状态",
    "submitForApproval": "提交审批",
    "toBeInvited": "待邀约",
    "updateDate": "更新时间",
    "view": "查看",
    "viewExhibitionCalendar": "查看展会日历",
    "vpSalesExport": "VP/Sales 导出",
    "whetherAttendParty": "是否参加派对",
    "wholesaler": "批发商",
    "salesAnalysis": "销售分析"
  },
  "Competing": {
    "formlable0": "竞品标题",
    "formlable1": "竞品金额",
    "formlable2": "竞品详情",
    "formlable3": "备注",
    "formlable4": "上传人",
    "formlable5": "日期",
    "formlable6": "国家/地区",
    "tabTitle1": "竞品标题",
    "tabTitle2": "竞品金额",
    "tabTitle3": "竞品信息"
  },
  "CompetitiveProductAnalysisDataListPage": {
    "addCompany": "新增公司",
    "addCustomer": "新增客户",
    "cd": "竞品与摆品",
    "competitorNum": "上传竞品数量",
    "country": "国家/地区",
    "customerName": "客户名",
    "editCompany": "编辑公司",
    "editCustomer": "编辑客户",
    "exportCompetingProducts": "导出竞品",
    "handle": "操作",
    "inset": "新增竞品",
    "lastEditDate": "最后编辑时间",
    "recentUploadTime": "最近上传时间",
    "sales": "Sales",
    "save": "新增/编辑竞品",
    "uploadDate": "上传时间",
    "uploader": "上传人",
    "view": "竞品预览",
    "vp": "VP"
  },
  "CompetitiveProductAnalysisPage": {
    "categoryList": "请选择品类",
    "collaborated": "已合作",
    "gradeList": "请选择档次",
    "materialList": "请选择材质",
    "nonCollaborated": "未合作",
    "priceBandList": "请选择价格带(零售价$)",
    "selectTips": "请选择",
    "table": {
      "competitorCustomersNotUploaded": "未上传竞品客户数",
      "competitorCustomersUploaded": "已上传竞品客户数",
      "division": "事业部",
      "handle": "操作",
      "insert": "添加信息",
      "newRate": "上传进度",
      "title1": "竞品分析",
      "title2": "开始时间",
      "title3": "结束时间",
      "title4": "账户数量",
      "totalCustomerCount": "总客户数",
      "uploadRate": "上传率",
      "view": "预览"
    },
    "to": "至",
    "tup": "总上传进度",
    "tur": "总上传率",
    "viewUploadedCompetitiveProductInformation": "查看已上传竞品信息"
  },
  "CompetitiveProductAnalysisStylePage": {
    "Currency": "币种",
    "add": "添加",
    "addFrame": "添加款式",
    "arrangementType": "组合类型",
    "category": "产品分类",
    "classification": "档次",
    "clickUpload": "点击上传",
    "column": "栏位",
    "company": "公司",
    "cover": "面料",
    "covers": "面料清单",
    "customer": "客户",
    "delete": "删除",
    "dimensionType": "尺寸",
    "displaySection": "展示",
    "dragUploadText": "将文件拖到此处，或",
    "exhibitionPrice": "展会价",
    "features": "功能特点",
    "filterPlaceholder": "请输入",
    "floorDisplayNumber": "摆场数",
    "fobPrice": "出厂价",
    "function": "功能",
    "image": "图片",
    "images": "副图",
    "leve": "档次",
    "model": "型号",
    "newFunctions": "推销功能",
    "no": "否",
    "notes": "备注",
    "onlineOnly": "是否仅为线上销售",
    "pdc": "产品类别",
    "price": "价格",
    "priceRange": "价格区间(零售价$)",
    "productName": "产品名",
    "salesType": "状态",
    "search": "搜索",
    "size": "尺寸（长*宽*高）",
    "tableSection": "表格",
    "type": "品类",
    "types": "推销类型",
    "update": "更新",
    "uploadExceedLimit": "最多只能上传{limit}个文件",
    "uploadFailed": "上传失败",
    "uploadImageFormatError": "只能上传mp4/avi格式的文件",
    "uploadImageSizeError": "上传文件大小不能超过{size}MB",
    "uploadTip": "只能上传jpg/png文件，且不超过{size}MB",
    "vendor": "供应商",
    "yes": "是"
  },
  "ConfirmOperation": "确认操作",
  "ContainerDimensions": {
    "allowed": "是否允许",
    "dialogTitle": "{t} (单位:in)",
    "flatPosition": "躺放",
    "flatWithHorizontalRotation": "躺放水平旋转",
    "height": "高",
    "length": "长",
    "materialNo": "物料号",
    "mixedStackingAllowed": "上面放置别的种类货物",
    "no": "否",
    "notAllowed": "不允许",
    "onSidePosition": "侧放",
    "onSideWithHorizontalRotation": "侧放水平旋转",
    "packageSize": "包装尺寸:{t}(in)",
    "permitted": "允许",
    "placementMethod": "摆放方式",
    "stackingTiers": "堆码层数",
    "tips": "说明：没有特殊限制以下选项可以为空，如有特殊限制请在对应摆放方式是否允许选项中选择否，上面放置别的种类货物选择不允许，堆码层数用数字填写允许的最大层数",
    "uprightPosition": "立放",
    "uprightWithHorizontalRotation": "立放水平旋转",
    "width": "宽"
  },
  "CopyLinks": "复制链接",
  "CountryNotselected": "未选择国家",
  "Customer": {
    "AddNewCustomerData": "新增客户数据添加",
    "ApproxFurnitureSales": "大约沙发生意额",
    "CustomerAnualSales": "年度生意额",
    "CustomerInformationion": "客户情况表",
    "CustomerManagement": "客户管理",
    "LocalRanking": "当地排名",
    "ManWahSales": "今年敏华生意额",
    "StoreNumber": "门店数量",
    "TargetSales": "今年目标生意额",
    "ViaitingTimeLately": "拜访时间",
    "level": "等级",
    "state": "地区"
  },
  "CustomerPage": {
    "AccountReceivable": "应收款",
    "AddBusinessCard": "添加名片",
    "AddCustomer": "新增意向",
    "AmountReceivable": "应收款",
    "Attachment": "添加附件",
    "CNCSR": "中国跟单",
    "CREDITTRADEREFERENCES": "保险信息",
    "CType": "客户类型",
    "City": "城市",
    "Cname": "客户名称",
    "Cnumber": "客户编号",
    "CompensationratioofRejection": "拒收赔偿比例",
    "Confirm": "意向等级",
    "Country": "国家/地区",
    "Credit": "保险额度",
    "CreditLine": "信用额度",
    "CreditPeriodDays": "信用期限(天)",
    "CustomerDet": {
      "thTitle1": "时间",
      "thTitle10": "产品代码",
      "thTitle11": "SKU号",
      "thTitle12": "款式",
      "thTitle13": "规格",
      "thTitle14": "物料号",
      "thTitle14s": "物料号",
      "thTitle15": "国贸条款",
      "thTitle16": "材质",
      "thTitle17": "颜色",
      "thTitle18": "成交价",
      "thTitle19": "本年累计出货金额",
      "thTitle2": "本月销售金额",
      "thTitle20": "去年累计出货金额",
      "thTitle21": "累计出货额同比增长",
      "thTitle22": "图片",
      "thTitle23": "本期累计出货金额",
      "thTitle24": "出货金额对比销售金额",
      "thTitle25": "品牌",
      "thTitle26": "失效日期",
      "thTitle27": "销售部门",
      "thTitle28": "上期累计出货金额",
      "thTitle29": "同期对比",
      "thTitle3": "去年同期",
      "thTitle30": "本期累计出货数量",
      "thTitle31": "上期累计出货数量",
      "thTitle32": "出货数量对比销售数量",
      "thTitle33": "开票金额",
      "thTitle34": "开票数量",
      "thTitle35": "首次出货日期",
      "thTitle36": "客户成交价",
      "thTitle37": "FOB价(含关税)",
      "thTitle38": "FOB价",
      "thTitle39": "客户成交价(含关税)",
      "thTitle4": "月同比",
      "thTitle40": "{t} 预算总金额",
      "thTitle5": "费用类型",
      "thTitle6": "本期金额",
      "thTitle7": "销售金额",
      "thTitle8": "模型",
      "thTitle9": "规格",
      "tnouo": "未出货金额"
    },
    "EffectiveDate": "额度生效日期",
    "ExpiryDate": "额度到期日期",
    "Fabric": "面料",
    "InCompany": "保险公司",
    "InsuranceCompany": "保险公司",
    "LineUp": {
      "addFloorSlot": "添加为店面现有",
      "amount": "金额",
      "blankets": "皮/布",
      "budget": "{t} 年预算",
      "coverCode": "色号",
      "coverName": "颜色名称",
      "floorDisplays": "摆场数",
      "fobPrice": "售价",
      "growthRate": "增长率",
      "introductionDate": "首次出货日",
      "level": "档次",
      "model": "款式",
      "openOrders": "未出货订单柜数",
      "picture": "图片",
      "previousYearJanDec": "{t} 全年销售额",
      "salesYTD": "{t} 销售额",
      "samePeriodSalesPreviousYear": "{t} 同时段销售额",
      "sku": "规格",
      "spec": "规格",
      "status": "状态",
      "year": "年"
    },
    "MWVP": "敏华海外VP/SALES/助理/跟单员信息",
    "MainImage": "是否主图",
    "OverdueAmount": "逾期金额",
    "PoCode": "邮政编码",
    "RegionalVP": "海外VP",
    "Remark": "备注",
    "STP": "货物送达方",
    "SalesRepresentive": "海外sales",
    "SkuClass": "款式类型",
    "Sponge": "海绵",
    "TOT": "贸易条款",
    "VNCSR": "越南跟单",
    "VPAssistant": "VP助理",
    "Variation": "变式",
    "addr": "地址",
    "comments": "SPECIAL INSTRUCTIONS / COMMENTS",
    "mainPhoto": "主图",
    "modelTye": "客户新款",
    "no": "否",
    "paymentTerm": "付款条件",
    "price": "销售价",
    "priceSecond": "FOB工厂价",
    "prices": "FOB审批价",
    "quty": "意向柜数",
    "rate": "同比%",
    "saleDept": "销售部门",
    "sato": "接单统计分析表",
    "tabTitle1": "销售总额",
    "tabTitle2": "款式排行",
    "tabTitle3": "船务异常费用",
    "tabTitle4": "Line Up",
    "tabTitle5": "客户折扣汇总",
    "tabTitle6": "客户信息",
    "tb1": "姓名",
    "tel": "电话",
    "tips": "当前款式已有主图，是否确认替换?",
    "tipsInfo": "上传图片不是标准16:9长宽比例主图，会影响导出展示，请尽量上传标准长宽比例产品图",
    "wip": "订单金额汇总",
    "yes": "是"
  },
  "Date": "日期",
  "DepPleaseSelectBrand": "请选择品牌",
  "DepPleaseSelectFactory": "请选择工厂",
  "Documents": {
    "filetitle": "文件标题",
    "uptime": "上传日期",
    "usDp": "美国事业部"
  },
  "Download": "下载",
  "Downloads": "下载",
  "EditCover": "编辑面料",
  "EditVideo": "编辑视频/图片",
  "EndDate": "结束时间",
  "ExReservationInvitationSummary": {
    "achievementRate": "达成率",
    "division": "事业部",
    "invitationAchievementRate": "邀约达成率",
    "numberOfClients": "客户数",
    "numberOfClientsDecliningAttendance": "不出席客户数",
    "numberOfClientsInvited": "已邀约客户数",
    "numberOfCollaboratedClients": "已合作客户数",
    "numberOfNonCollaboratedClients": "未合作客户数",
    "plannedInvitationRate": "计划邀约率",
    "plannedInvitationRateForCurrentExhibition": "本次展会计划邀约率",
    "plannedNumberOfClientsToInvite": "计划邀约客户数",
    "title": "展会邀约汇总表",
    "totalInvitationsCompleted": "已邀约总数",
    "totalNumberOfClients": "总客户数",
    "totalPlannedInvitations": "计划邀约总数",
    "LYIC": "去年邀约客户数",
    "YR": "同比"
  },
  "FileIsNull": "文件为空",
  "Firstlevelreport": "一级报告",
  "Hello": "你好",
  "HiRes": "视觉效果图",
  "Home": {
    "Department": "请选择部门",
    "Isitoverdue": "是否逾期",
    "OverdueAmount": "逾期金额",
    "SaleAmount": "销售总额",
    "charTitle1": "月销售额同比",
    "charTitle2": "接单出货订单表",
    "charTitle3": "客户销售排名",
    "charTitle4": "逾期金额排名前十",
    "charTitle5": "款式销售排名前十金额占比",
    "charTitle6": "部门款式销售排名前十金额占比",
    "charTitle7": "颜色排行销售排行前十",
    "charTitle8": "部门颜色排行销售排行前十",
    "color": "颜色",
    "lastYear": "去年",
    "money": "金额",
    "more": "更多",
    "radio": "占比",
    "tbTitle1": "客户名称",
    "tbTitle2": "本月销售金额",
    "tbTitle3": "去年同期",
    "tbTitle4": "应收总额",
    "tbTitle5": "月同比",
    "thisYear": "今年"
  },
  "ImagesAndVideo": {
    "Body": "内容",
    "Clear": "清除",
    "EmailTo": "电子邮件地址",
    "SendEmail": "发送电子邮件",
    "Subject": "标题",
    "remove": "删除",
    "type": "类型"
  },
  "InventoryPlatform": {
    "ADOL": "延期天数(担保-ETD/ETA)",
    "ALT": "交期(建单/回签-ETD)",
    "APAD": "回签天数(建单-回签)",
    "APD": "生产天数(回签-实际完工)",
    "ASD": "出货天数(实际完工-ETD)",
    "ActualReadyDate": "实际完工日",
    "CCD": "竞品创建日期",
    "Container": "货柜号",
    "CustomerInventory": "客户库存",
    "CustomerInventoryInfoTpl": "客户库存信息模板",
    "DeliverNo": "交货单",
    "ETA": "预计到港日",
    "ETD": "预计离港日",
    "EstReadyDate": "预计完工日",
    "FCD": "工厂确认(首次)",
    "FCN": "工厂日期(最后)",
    "IHOQ": "有单未出",
    "ImportSuccessful": "导入成功",
    "InProduction": "生产中",
    "IncorrectDownload": "异常下载",
    "LoadingDate": "装柜日",
    "MeterialAvailableStock": "物料库存（面料）",
    "MeterialInTransit": "物料在途（面料）",
    "OAR": "变更原因",
    "OrderQuantity": "订单数量",
    "PAD": "回签日期",
    "PAFC": "生产确认天数 (回签-工厂确认)",
    "PCD": "采购确认天数(回签-采购确认)",
    "MOD": "到料准时天数(占位-到料-15天)",
    "POTD": "生产准时天数(占位-实际完工)",
    "PCFT": "采购确认(首次)",
    "UPD": "采购日期(最后)",
    "PD": "建单日期",
    "PO": "PO#",
    "ProductInStock": "成品库存",
    "ProductInTransit": "产品在途",
    "ProductInfo": "产品信息",
    "ProductInfoTpl": "产品信息模板",
    "ReadyDate": "完工时间",
    "ReplenishmentQTY": "补货数量",
    "RequestReadyDate": "业务要求完工日",
    "SRD": "收SO日期",
    "SRL": "收SO-装柜",
    "ShippedQuantity": "发货数量",
    "StockQTY": "库存数量",
    "StockQTYs": "在库数量",
    "TAPOS": "平均交期",
    "ThisWeekInvoice": "本周开单",
    "UnProduced": "已下单未生产",
    "WeekEndTime": "周结束时间",
    "WeekStartTime": "周开始时间",
    "adtips": "延期天数",
    "basicInfo": "基本信息",
    "cancel": "取消",
    "categoryId": "品类",
    "changeDays": "变更天数",
    "color": "颜色",
    "confirm": "确定",
    "containerNumber": "预估柜数",
    "createTime": "创建时间",
    "createUser": "创建用户",
    "customer": "客户",
    "customerCode": "客户代码",
    "customerDataTpl": "客户数据模板",
    "customerName": "客户名称",
    "customerPo": "客户PO",
    "customerSKU": "客户SKU#",
    "deleteConfirm": "是否删除所选记录?",
    "deleteSuccessful": "删除成功",
    "disable": "停用",
    "enable": "启用",
    "endMonth": "结束月份",
    "eta": "ETA",
    "etd": "ETD",
    "fabricNumber": "面料编号",
    "features": "功能特点",
    "file": "文件",
    "item": "规格",
    "model": "款式",
    "mwSKU": "敏华物料号",
    "numberOfStore": "门店数量",
    "operate": "操作",
    "pleaseSelectData": "请选择数据",
    "po": "订单号",
    "prompt": "提示",
    "remark": "备注",
    "save": "保存",
    "saveSuccess": "保存成功",
    "seq": "序号",
    "shipTo": "目的地",
    "sku": "Sku",
    "startMonth": "开始月份",
    "status": "状态",
    "storeFloorSampleQTY": "门店摆场数",
    "supplier": "供应商",
    "undeliveriedQTY": "客户有单未送",
    "uploadTip1": "文件大小不能超过5M",
    "uploadTip2": "文档行数不能超过10000万行",
    "weekDate": "周日期"
  },
  "Large": "大型的",
  "LifeStyle": "生活时尚",
  "MainPushStyleSalesRanking": {
    "category": "品类",
    "categoryRanking": "品类排名",
    "color": "颜色",
    "cumulativeNetSales": "近半年累计销售净额",
    "customer": "主要客户",
    "department": "部门",
    "fandm": "规格/物料号",
    "ferth": "规格",
    "fobPrice": "FOB标准价",
    "level": "档次",
    "levelRanking": "档次排名",
    "mark": "备注",
    "model": "款式",
    "netSales": "{t}销售净额",
    "numbersOfDisplay": "摆场数",
    "orderQuantityInIheNext3months": "未来3个月订单数量(件)  ({t})",
    "picture": "图片",
    "recommendedStatus": "推荐状态",
    "running": "是否主推",
    "type": "材质"
  },
  "Medium": "中等的",
  "ModelsDet": {
    "title": "定价和图像"
  },
  "MonthRange": "ETD日期",
  "Normal": "普通",
  "OrderAverageDeliveryTime": {
    "cargoState": "货物状态",
    "customerName": "客户名称",
    "exportFileName": "客户平均货期",
    "no": "序号",
    "orderA2C": "订单A→C",
    "orderC2D": "订单C→D",
    "orderCompleted2Delivery": "装柜→发货过账",
    "orderCompleted2Vanning": "订单完工→装柜",
    "orderCreateTime": "订单创建年月",
    "orderD2Completed": "订单D→实际完工",
    "orderOccupationTime": "订单占位年月",
    "orderQuantity": "订单数量",
    "shipped": "已发货",
    "total": "总周期(订单A→发货过账)",
    "unshipped": "未发货",
    "vpSales": "VP/Sales"
  },
  "OrderDeliveryTimeOverviewOrDetail": {
    "create": "创建",
    "currentStatus": "当前状态",
    "custom": "客户",
    "acStatus": "A&C",
    "cycleConditions": "周期条件",
    "day": "天",
    "deliveryOrNot": "是否发货",
    "figure1": "平均货期",
    "figure2": "货期分段",
    "firstDeliveryDate": "首次交期",
    "hasBeenShipped": "已发货",
    "haveBeenCompleted": "已完工",
    "haveSigned": "已签订",
    "inTheProduction": "生产中",
    "installedCabinet": "已装柜",
    "invalidDateRange": "无效的日期范围",
    "month": "月",
    "orderA2C": "订单A→C",
    "orderA2Delivery": "订单A→发货",
    "orderC2D": "订单C→D",
    "orderCompleted2Delivery": "装柜→发货过账",
    "orderCompleted2Vanning": "订单完工→装柜",
    "orderCreareDate": "订单创建日期",
    "orderCreateTime": "订单创建月份",
    "orderD2Completed": "订单D→实际完工",
    "orderD2Delivery": "订单D→发货",
    "orderD2ExpectedCompleted": "订单D→预计完工",
    "orderId": "订单号",
    "orderOccupationTime": "订单占位月份",
    "reviewDateD": "首次审D日期",
    "siteValidation": "工厂确认",
    "title1": "已发货平均货期走势(单位:天)",
    "title2": "货期分布(单位:单数)",
    "total": "总计",
    "totalDeliveryTime": "总货期"
  },
  "OrderInput": "订单输入汇总",
  "OrderInputDetailList": "订单输入明细表",
  "OrderIntake": {
    "TooC": "未出货柜数",
    "styleStatisticalDetail": "款式统计详情",
    "styleCode": "款式编码",
    "bookDate": "下单日期",
    "color": "颜色",
    "currentMonthDeliveries": "本月出货",
    "customerName": "客户",
    "customerOrderNumber": "客户订单号",
    "lastMonthShipments": "上月出货",
    "monthDate": "交期",
    "mp": "物料参数",
    "numberOfDisplaySetups": "摆场数",
    "occupancyDate": "占位日期",
    "styleOrderInfo": "款式订单信息",
    "styleInfo": "款式信息",
    "orderInfo": "订单信息",
    "orderNum": "订单数量",
    "ordersReceivedLastMonth": "上月接单",
    "quantity": "柜量",
    "salesOrder": "销售订单",
    "spec": "规格",
    "status": "状态",
    "style": "款式",
    "subtotal": "小计",
    "total": "总计",
    "unitPrice": "单价",
    "vpSales": "VP/Sales",
    "noSo": "在库无SO",
    "noSoInfo": "在库无SO信息"
  },
  "OrderPage": {
    "Destination": "目的地",
    "Order": "销售订单",
    "OrderDate": "下单日期",
    "PONO": "客户订单号",
    "PaymentTerms": "付款方式",
    "Period": "占位日期",
    "indexTb": {
      "t1": "客户代码",
      "t2": "客户名字",
      "t3": "订单创建",
      "t4": "已签订",
      "t5": "工厂确认",
      "t6": "生产中",
      "t7": "完工在库",
      "t8": "已发货",
      "t9": "全部"
    },
    "orderlist": {
      "th1": "客户要求交期",
      "th10": "预计开船日",
      "th11": "Actual Completion Date",
      "th12": "货柜号",
      "th13": "POD状态",
      "th14": "预计到港日",
      "th15": "发票号",
      "th16": "发票金额",
      "th17": "实际完工日期",
      "th2": "收客户po日期",
      "th3": "占位时间",
      "th4": "款式",
      "th5": "颜色特性",
      "th6": "品牌类别",
      "th7": "预计到料日",
      "th8": "实际到料日 ",
      "th9": "预计完工日"
    },
    "payTerms": "付款条件",
    "tabTitle1": "全部",
    "tabTitle2": "订单创建",
    "tabTitle3": "已签订",
    "tabTitle4": "工厂确认",
    "tabTitle5": "生产中",
    "tabTitle6": "完工在库",
    "tabTitle7": "已发货",
    "thead": {
      "title1": "款式",
      "title2": "规格",
      "title3": "颜色特性",
      "title4": "订单数量",
      "title5": "单价"
    }
  },
  "Performance": {
    "Acutal1": "2023全年",
    "Acutal2": "2019全年",
    "BIT": "预算导入模板",
    "Budget": "2024年1-12月预算",
    "Division1": "Total",
    "Division2": "出口二部",
    "Division3": "出口三部",
    "ESAPC": "客户销售情况表",
    "cabinet": "柜数",
    "tabTitle0": "客户名称",
    "tabTitle1": "预算",
    "tabTitle10": "同期对比",
    "tabTitle11": "全年实际",
    "tabTitle2": "实际",
    "tabTitle3": "实际",
    "tabTitle4": "目标达成率",
    "tabTitle5": "同期对比",
    "tabTitle6": "预算",
    "tabTitle7": "实际",
    "tabTitle8": "实际",
    "tabTitle9": "目标达成率",
    "vpassistant": "VP助理"
  },
  "PleaseConfirmPassword": "请再输入一次",
  "PleaseEnter": "请输入",
  "PleaseEnterNewPassword": "请输入新密码",
  "PleaseInput": "请输入",
  "PleaseInputBudge": "请输入预算",
  "PleaseInputColor": "请输入颜色特性",
  "PleaseInputCubes": "请输入平方",
  "PleaseInputDepth": "请输入深度",
  "PleaseInputDescription": "请输入说明",
  "PleaseInputLength": "请输入长度",
  "PleaseInputPrice": "请输入价格",
  "PleaseInputSku": "请输入sku",
  "PleaseInputTitle": "请输入标题",
  "PleaseInputcovers": "请输入覆盖物",
  "PleaseSelect": "请选择",
  "PleaseSelectArrangements": "请选择布局",
  "PleaseSelectModel": "请选择型号",
  "PleaseSelectTheDownloadMethod": "请选择下载方式!?",
  "PleaseSelectType": "请选择类型",
  "Receivables": "逾期应收账款",
  "Report": {
    "AllTypes": "所有类型",
    "PleaseEnterCodeOrName": "请输入客户代码或者名称",
    "PleaseEnterNameSearch": "请输入姓名进行搜索"
  },
  "Secondaryreport": "二级报告",
  "SelectFile": "选择文件",
  "SendContentViaEmail": "通过电子邮件发送内容",
  "ShippedDetailList": "出货明细表",
  "ShippedOrderSummary": "发货订单汇总",
  "Small": "小型的",
  "StartDate": "开始时间",
  "Temporarily": "暂无数据",
  "Tips": "提示",
  "ToDoReminder": {
    "competingProductsRelated": "订单相关",
    "marketsRelated": "展会相关",
    "orderRelated": "竞品相关",
    "otherRelated": "其他"
  },
  "ToSendToMultipleEmails": "要发送到多个电子邮件，请在地址之间添加一个 com",
  "TravelList": {
    "byway": "Others"
  },
  "UploadPicturesCaninJPGformat": "上传图片只能是JPG格式",
  "Videos": "视频",
  "VisitTime": "访问时间",
  "addCompetitors": {
    "PleaseInputAmount": "请输入金额",
    "PleaseInputCustomerDescribe": "请输入客户描述",
    "PleaseInputDetails": "请输入详细信息",
    "PleaseInputTitle": "请输入标题",
    "PleaseInputUserName": "请输入用户姓名",
    "selectdate": "选择日期"
  },
  "addSuccess": "添加成功",
  "addTravel": {
    "CustomerDetailsP": "请输入客户资料",
    "CustomerLocation": "请输入客户所在地",
    "CustomerName": "请输入客户名称",
    "Opportunity": "请输入感想",
    "PleaseInputContacts": "请输入联系人"
  },
  "competingGoodsInfo": {
    "Commitments": "展会列表",
    "title1": "SKU",
    "title2": "说明",
    "title3": "平方",
    "title4": "长度",
    "title5": "深度",
    "title6": "价格",
    "title7": "总价格"
  },
  "confirm": "确 认",
  "confirmError": "两次输入的密码不一致",
  "confirmPassword": "确认密码",
  "covers": {
    "coverGroup": "面料组别",
    "coverName": "面料名",
    "coverNumber": "面料号",
    "coverType": "面料类型"
  },
  "dash": {
    "Year": "请选择年"
  },
  "editPricelist": "编辑价目表",
  "factory": "工厂",
  "firstLogin": "首次登录或密码过于简单",
  "formlabel": {
    "Count": "总合计",
    "Department": "部门",
    "Month": "月度",
    "Quarter": "季度",
    "ResetBtn": "重置",
    "ReturnBtn": "返回",
    "SearchBtn": "搜索",
    "Selectfile": "选择文件",
    "SingleBtn1": "接单订单",
    "SingleBtn2": "出货订单",
    "SingleCount": "接单总数",
    "SingleCounts": "出货总数",
    "Year": "年度",
    "addBtn": "添加",
    "allExport": "全部导出",
    "cancel": "取消",
    "classify": "分类",
    "createCommitment": "创建",
    "createdDate": "创建日期",
    "delete": "删除",
    "download": "下载上传模版",
    "downloadTemplate": "下载模板",
    "downloadbtn": "下载",
    "editBtn": "编辑",
    "export": "导出",
    "exportCountSheet": "导出订单汇总",
    "exportData": "导出报表",
    "lineup": "导出Line Up",
    "exportDataAll": "导出意向订单品类明细",
    "exportDataAllT": "导出订单状态明细",
    "exportDataSecond": "导出意向订单",
    "exportDataThree": "导出订单状态",
    "exportDatas": "导出意向订单列表",
    "exportNewData": "导出意向订单统计表",
    "exportExcel": "导出Excel",
    "exportExcel1": "只包含主图",
    "exportExcel2": "包含主图跟副图",
    "exportPdf": "导出PDF",
    "exportType": "展会邀约客户信息",
    "handle": "操作",
    "import": "导入",
    "keyword": "关键字",
    "label1": "客户邀约资料报表",
    "label2": "客户邀约资料更新模板",
    "label3": "分页导出",
    "label4": "合并导出",
    "label5": "交期信息明细表",
    "label6": "客户回签信息明细表",
    "label7": "在库天数逾期报表",
    "label8": "出口业务部在库天数数据分析",
    "partExport": "部分导出",
    "submitBtn": "提交",
    "title": "标题",
    "updateDate": "更新日期",
    "upload": "上传",
    "exportAnsis": "导出意向订单分析表"
  },
  "level": "等级",
  "loading": "加载中",
  "logout": "退 出",
  "logoutConfirm": "确定注销并退出系统吗？",
  "menu": {
    "menu_title15": "市场列表",
    "menu_title16": "意向列表",
    "menu_title17": "展会接单情况表",
    "menu_title18": "模型概括"
  },
  "menus": {
    "Account": "账户",
    "AccountHierarchySettings": "账号上下级设置",
    "Admin": "管理员",
    "Arms": "扶手",
    "Arrangements": "组合",
    "Backs": "靠背",
    "Catalog": "文档",
    "Categories": "类别",
    "Commitments": "展会列表",
    "CompetitiveProductAnalysis": "客户竞品",
    "CompetitiveProductAnalysisDataList": "竞品客户明细表",
    "Competitorslist": "竞品相关",
    "ConfirmOrderDetails": "展会确认订单明细表",
    "ContainerDimensions": "装柜尺寸",
    "ContentRelated": "图片相关",
    "Cover": "面料",
    "CoverFeature": "面料特性",
    "Covers": "颜色",
    "CoversGrades": "颜色等级",
    "CoversGroups": "颜色组",
    "CoversRelated": "颜色相关",
    "Customer": "客户",
    "CustomerManagement": "客户管理",
    "CustomerSalesInfo": "客户信息管理",
    "DFSEDIInvolce": "DFS EDI 发票",
    "Documents": "文档",
    "ExReservation": "展会预约",
    "ExReservationInvitationSummary": "展会预约",
    "ExReservationInvitationSummaryForBusiness": "展会邀约汇总表",
    "ExReservationTabs": "展会邀约客户信息",
    "ExhibitionBonusDistribution": "展会奖金分配",
    "ExhibitionBonusStyles": "展会奖金款式",
    "ExportDeliveryReport": "客户交期跟踪报表",
    "Features": "产品特点",
    "FinanceReports": "财务报表",
    "FollowUpSituationTable": "展会订单跟进情况表",
    "Frames": "产品相关",
    "InventoryPlatform": "库存平台",
    "InventoryPlatformCustomerData": "客户数据",
    "InventoryPlatformCustomerDataNew": "客户数据",
    "InventoryPlatformProductInfoConfig": "产品信息配置",
    "InventoryPlatformSharingReport": "共享报表",
    "InventoryReport": "库存报表",
    "LeaderboardReport": "排行榜",
    "MainPushStyleSalesRanking": "款式销量排行榜",
    "MainPushStyleSalesRankingTwo": "款式销量排行榜",
    "MarketNewModelBonusReport": "展会奖金报表",
    "Mechanisms": "功能铁架",
    "Models": "款式列表",
    "NewModelRelated": "新款相关",
    "NewStyleMaintenance": "新款维护",
    "Order": "订单",
    "OrderAverageDeliveryTime": "客户平均货期",
    "OrderDeliveryTimeDetail": "货期详情",
    "OrderDeliveryTimeOverview": "货期概览",
    "OrderIntake": "接单情况",
    "OrderStatus": "订单状态",
    "Performance": "业绩分析",
    "Photos": "图片",
    "Price": "价格",
    "PriceParent": "价格",
    "ProductRecommendation": "竞品信息",
    "Report": "报表",
    "ReportEight": "款式销售汇总排名",
    "ReportEleven": "业务出货及收入情况表",
    "ReportFive": "出口在库完工柜报表",
    "ReportFour": "船务异常费用",
    "ReportNine": "销售明细表",
    "ReportOne": "销售净额分析表",
    "ReportSeven": "销售颜色汇总排名",
    "ReportSix": "客户销售汇总排名",
    "ReportTen": "业务接单情况表",
    "ReportThree": "接单出货订单表",
    "ReportTwenty": "客户摆品及竞品情况",
    "ReportTwentyV2": "客户摆品及竞品情况",
    "ReportTwo": "应收账款逾期账龄分析表",
    "RevenueReport": "业务出货及收入情况表",
    "SKU": "规格",
    "SalesReports": "销售报表",
    "Seats": "座包",
    "SpecificationRelationship": "规格关系",
    "Styles": "产品风格",
    "ToDoReminder": "待办事项",
    "TotalCommitments": "款式总结",
    "Travel": "出差",
    "TravelTabs": "出差",
    "Video": "视频",
    "Videos": "视频",
    "achievement": "业绩",
    "cart": "选购清单",
    "competingGoods": "报价单",
    "competitors": "竞品",
    "createdAccount": "账户管理",
    "exhibition": "展会",
    "index": "首页",
    "lmageVideo": "图片和视频",
    "loginlog": "登录日志",
    "modelsManager": "款式",
    "mwhCompetitorFeatures": "竞品产品特点",
    "newCP": "公司竞品",
    "newCompetions": "竞品",
    "newPrices": "价格",
    "others": "其他",
    "poList": "PI清单",
    "qsInventory": "QS款式列表",
    "qsReport": "QS报表",
    "quotationSheet": "报价单",
    "rai": "离职继承",
    "relatingPrices": "价格",
    "resetPassword": "重置密码",
    "tableList": "展会接单情况表",
    "tableListbyCustomer": "意向清单",
    "usCP": "Southern Motion",
    "vpsalesMezzanine": "竞品客户汇总表"
  },
  "menusObj": {
    "menu_title1": "首页",
    "menu_title10": "知识库",
    "menu_title11": "业绩",
    "menu_title12": "图片和视频",
    "menu_title13": "模型",
    "menu_title14": "价格",
    "menu_title15": "客户价目表",
    "menu_title16": "市场",
    "menu_title17": "PortalCommitments",
    "menu_title2": "客户",
    "menu_title3": "订单",
    "menu_title4": "报表",
    "menu_title5": "出差",
    "menu_title6": "竞品",
    "menu_title7": "商品",
    "menu_title8": "展会",
    "menu_title9": "视频"
  },
  "model": "型号",
  "modelStatus": {
    "dropped": "取消",
    "newCover": "新款",
    "newModel": "新款",
    "phasedOut": "逐步淘汰",
    "running": "主推"
  },
  "modifyPassword": "修改密码",
  "newPassword": "新密码",
  "newPriceList": {
    "Comments": "评论",
    "Created": "创建",
    "Link": "关联",
    "Rep": "Rep",
    "Updated": "更新",
    "columns1": "越南/加拿大",
    "columns2": "CFR",
    "columns3": "FOB",
    "columns4": "图片",
    "createdPricelist": "确认价格表单",
    "entries": "条目",
    "pricelistForm": "价格表单",
    "title1": "条款",
    "typeToFilter": "筛选类型"
  },
  "no": "序号",
  "noMore": "没有更多了",
  "oldPassword": "旧密码",
  "order": {
    "Division": "事业部",
    "Market": "市场",
    "PleaseEnterTheSearchKeyword": "请输入搜索关键字"
  },
  "others": {
    "DFSEDIInvolce": {
      "EDIFileName": "EDI文件名",
      "ExportEDIFile": "导出EDI文件",
      "ExportPOFile": "导出PO文件",
      "lnvoiceCode": "发票"
    }
  },
  "pageTitle": {
    "CompetitiveProductAnalysis": "竞品分析",
    "Customer": "客户",
    "CustomerDet": "客户详情",
    "Order": "订单",
    "OrderStatus": "订单状态",
    "TravelList": "出差列表"
  },
  "passwordNoChange": "新密码不能与旧密码相同",
  "passwordRequirements": "密码必须是8位以上的大写字母、小写字母、数字的组合",
  "price": {
    "Current": "品牌",
    "From": {
      "Arms": "Arms",
      "Close": "关闭",
      "Construction": "结构",
      "CountryOfOrigin": "原产地",
      "CreateModel": "创建模型",
      "ModelForm": "模型形式",
      "Name": "名称",
      "Remarks": "评价",
      "Style": "风格特征",
      "Unique": "独特的"
    },
    "NewModel": "新模型",
    "TypeToFilter": "要过滤的类型",
    "addtoTheOriginalCombination": "添加到原组合",
    "combinationName": "组合名称",
    "createNewCombination": "创建新组合",
    "modifyFunctionName": "修改功能名称",
    "modifyTheCombinationName": "修改组合名称",
    "table": {
      "Arms": "Arms",
      "Backs": "靠背",
      "Brand": "品牌",
      "Categories": "类别",
      "Collections": "系列",
      "Current": "Current",
      "Features": "特点",
      "Image": "图片",
      "Mechanisms": "Mechanisms",
      "Model": "型号",
      "Remarks": "评论",
      "Seats": "Seats",
      "Styles": "风格",
      "handle": "操作",
      "noPic": "暂无图片"
    }
  },
  "prices": {
    "CoverGrade": "表面等级",
    "CoverType": "表面材质",
    "Cube": "材积(m³)",
    "Cubes": "材积(ft³)",
    "Depth": "包装后宽(in)",
    "Depths": "包装后宽(cm)",
    "Edit": "编辑",
    "Function": "功能",
    "MaterialClass": "请选择材质类型",
    "MaterialInfo": "请选择颜色等级",
    "MotionType": "移动类型",
    "PieceCount": "件数",
    "PowerClass": "请选择功能类型",
    "Type": "材质等级",
    "addNewPriceSheet": "创建报价单",
    "addPriceSheet": "新增到报价单",
    "addToPriceSheet": "添加到报价单",
    "allPrice": "全部价格",
    "back": "返回",
    "category": "种类",
    "change": "修改",
    "chooseCover": "可选色",
    "clickPreview": "点击材质等级查看所有价格",
    "cnP": "中国FOB价格",
    "description": "商品名称",
    "errorTip": "组合名称和功能必填",
    "errorTips": "选择的价格重复，不可添加",
    "exportPriceSheet": "导出报价单",
    "factory": "请选择工厂",
    "height": "包装后高(in)",
    "heights": "包装后高(cm)",
    "length": "包装后长(in)",
    "lengths": "包装后长(cm)",
    "multipleSelection": "多选",
    "newPriceList": "新增价目表",
    "noPic": "没有可用图像",
    "priceEnd": "价格结束",
    "priceLists": "价格列表",
    "priceSheetColorNum": "选择报价单颜色编号",
    "priceSheetFileName": "报价单文件名",
    "priceSheetName": "报价单名称",
    "priceStart": "价格开始",
    "priceTickets": "价格牌",
    "priceValidity": "价格有效期",
    "pricesImportTemplate": "价格导入模板",
    "quoteLabel": "报价单",
    "quoteRequired": "报价单必选",
    "quoteSheet": "报价单",
    "radio1": "产品资料",
    "radio2": "手动添加",
    "radio3": "SAP",
    "rawPic": "白底图",
    "sceneGraph": "场景图",
    "search": "查询",
    "selectPic": "为报价单选择一张图片",
    "specificationNum": "规格数量",
    "style": "请输入款式",
    "titleInfo": "来源",
    "vietnamP": "越南FOB价格",
    "view": "查看",
    "viewPriceSheet": "查看报价单",
    "viewOrderList": "查看意向订单",
    "viewInfo": "意向"
  },
  "productRecommendation": {
    "Division": "事业部",
    "businessId": "业务工号",
    "businessName": "业务名称",
    "category": "类别",
    "color": "颜色",
    "customer": "客户",
    "exportProductRecommendationScheme": "{t}产品推荐方案",
    "exportProductRecommendationTable": "{t}产品推荐表",
    "exportProductRecommendationTemplate": "{t}产品推荐表模板",
    "fabric": "面料",
    "followRecords": "跟进记录",
    "functionFeatures": "功能特点",
    "importProductRecommendationTableInformation": "{t}产品推荐信息",
    "level": "档次",
    "material": "材质",
    "model": "款式",
    "price": "价格区间 （美元）",
    "recommendedPriority": "推荐优先级",
    "recommendedReason": "推荐理由",
    "required": "必填",
    "size": "尺寸",
    "specification": "规格",
    "style": "款式风格",
    "vpSales": "VP/Sales"
  },
  "psdiv": "请选择事业部",
  "report20": {
    "CRL": "客户排行榜",
    "FOBPrice": "零售价",
    "Fabric": "布类",
    "LandedPrice": "Landed审批卖价",
    "RetailPrice": "零售价",
    "classification": "档次",
    "floorSlot": "店面现有",
    "fobPrice": "出厂价",
    "leather": "皮类",
    "mwSlot": "敏华现有",
    "picture": "图片",
    "rank": "排名",
    "storeNumber": "门店数",
    "suppliers": "供应商",
    "total": "汇总Total"
  },
  "reportItem": {
    "ItemTitle1": "销售净额分析表",
    "ItemTitle10": "业务接单情况表",
    "ItemTitle11": "业务出货及收入情况表",
    "ItemTitle2": "应收账款逾期账龄分析表",
    "ItemTitle3": "接单出货订单表",
    "ItemTitle4": "船务异常费用",
    "ItemTitle5": "出口在库完工柜报表",
    "ItemTitle6": "客户销售汇总排名",
    "ItemTitle7": "销售颜色汇总排名",
    "ItemTitle8": "款式销售汇总排名",
    "ItemTitle9": "销售明细表",
    "Title": "报表"
  },
  "reportpage1": {
    "Ccode": "客户代码",
    "Cname": "客户名称",
    "NTitle1": "规格",
    "NTitle2": "意向柜数",
    "NTitle3": "落实订单件数",
    "NTitle4": "总金额(USD)",
    "NTitle5": "落实柜数",
    "VPname": "VP名",
    "title1": "本月发票金额",
    "title2": "去年同期发票金额",
    "title3": "同比变化率",
    "title4": "今年发票金额",
    "title5": "去年发票金额",
    "title6": "同比变化率"
  },
  "reportpage10": {
    "search": {
      "title1": "部门",
      "title2": "VP/Sales",
      "title3": "客户名称",
      "title4": "年月"
    },
    "thTitle": {
      "title1": "序号",
      "title10": "上月接单金额",
      "title11": "去年上月接单柜数",
      "title12": "去年上月接单金额",
      "title13": "上月金额同比增长%",
      "title14": "本月接单柜数",
      "title15": "本月接单金额",
      "title16": "去年同期接单柜数",
      "title17": "去年同期接单金额",
      "title18": "本月金额同比增长%",
      "title19": "本年累计接单柜数",
      "title2": "部门",
      "title20": "本年累计接单金额",
      "title21": "去年累计接单柜数",
      "title22": "去年累计接单金额",
      "title23": "累计接单金额同比增长%",
      "title3": "VP/Sales",
      "title4": "客户",
      "title5": "出差时间",
      "title6": "展会名称",
      "title7": "意向柜数",
      "title8": "确认柜数",
      "title9": "上月接单柜数"
    },
    "tips1": "接单开始日期不能大于结束日期",
    "tips2": "开票开始日期不能大于结束日期",
    "tips3": "接单只能导出半年内数据",
    "tips4": "开票只能导出半年内数据",
    "fieldA": "上个季度销售金额",
    "fieldB": "首次出货日期"
  },
  "reportpage11": {
    "search": {
      "title1": "部门",
      "title2": "VP/Sales",
      "title3": "客户名称",
      "title4": "年月"
    },
    "thTitle": {
      "title1": "序号",
      "title10": "金额",
      "title11": "下月以后出货柜数",
      "title12": "金额",
      "title2": "部门",
      "title3": "VP/Sales",
      "title4": "客户",
      "title5": "上月出货柜数",
      "title6": "金额",
      "title7": "折扣",
      "title8": "佣金收入",
      "title9": "本月应出货柜数"
    },
    "tips1": "接单开始日期不能大于结束日期",
    "tips2": "开票开始日期不能大于结束日期",
    "tips3": "接单只能导出半年内数据",
    "tips4": "开票只能导出半年内数据"
  },
  "reportpage2": {
    "Ccode": "客户代码",
    "Cname": "客户名称",
    "days": "天",
    "title1": "保险公司",
    "title2": "付款条件",
    "title3": "应收金额",
    "title4": "逾期金额",
    "title5": "最后付款日期",
    "title6": "上次付款金额"
  },
  "reportpage4": {
    "Ccode": "客户代码",
    "ChassisFee": "超期车架费用",
    "ChassisSplit": "车架分离费",
    "Cname": "客户名称",
    "CustomsExam": "海关查柜费",
    "Demurrage": "码头/火车站舱租",
    "DropPickUpFee": "返空/还空柜费",
    "ECD": "额外送货费",
    "OverTimeWaiting": "超时费",
    "PrePull": "外拖费",
    "Totalcost": "额外费用总计",
    "YardStorage": "堆存费"
  },
  "reportpage5": {
    "ECDDTR": "出口客户交期跟踪报表",
    "PI": "PI号",
    "actuallyFinishedDate": "实际完工日",
    "amercement": "扣款金额",
    "between120and150days": "121-150天",
    "between150and180days": "151-180天",
    "between15and30days": "16-30天",
    "between30and60days": "31-60天",
    "between60and90days": "61-90天",
    "between90and120days": "91-120天",
    "closingDate": "截关日期",
    "color": "颜色",
    "csr": "跟单",
    "customerCode": "客户代码",
    "customerName": "客户名称",
    "customerPO": "客户PO号",
    "day": "",
    "dept": "销售部门",
    "eta": "预计开船日",
    "etd": "预计到港日",
    "finishedDay": "完成时间",
    "finishedGoodsInventoryAgeReport": "在库天数信息报表",
    "finishedGoodsInventoryInformationReport": "在库订单SO情况",
    "fob": "价格",
    "hasSolution": "有/无解决方案",
    "incoterms": "国贸条款",
    "inventory": "在库库存",
    "lessThan15days": "15天以下",
    "material": "面料",
    "model": "型号",
    "more60Days": "60天以上",
    "openingDate": "开仓日期",
    "orderAmount": "订单金额",
    "orderWithSO": "已拿SO柜数",
    "orderWithoutSO": "未拿SO柜数",
    "ordersWithSO": "有SO订单数",
    "ordersWithoutSO": "无SO订单数",
    "over180days": "180天以上",
    "qty": "订单数量",
    "so": "SO号",
    "soFalse": "无SO",
    "soStatus": "SO情况",
    "soTrue": "有SO",
    "solution": "处理方案",
    "spec": "规格",
    "stockDays": "在库天数",
    "stockDaysScope": "在库天数范围",
    "totalOrders": "订单总数",
    "tradeTerms": "国际贸易条款",
    "tradeTerms2": "国际贸易条款2",
    "unit": "单位：柜数",
    "vbeln": "PI号",
    "viewScope": "查看范围",
    "vpAssistance": "VP助理",
    "zjsi": "截SI日期"
  },
  "reportpage8_7": {
    "Cname": "客户名称",
    "Country": "国家/地区",
    "TradeTerms1": "国际贸易条款1",
    "TradeTerms2": "国际贸易条款2",
    "code": "代号",
    "ctn": "在库柜数",
    "dept": "销售部门",
    "name": "名称",
    "title0": "颜色编码",
    "title1": "款式",
    "title2": "本月销售净额",
    "title3": "占比",
    "title4": "去年本月销售净额",
    "title5": "占比",
    "title6": "同比变化率",
    "title7": "今年累计销售净额",
    "title8": "去年累计销售净额",
    "title9": "同比变化率"
  },
  "reportpage9": {
    "search": {
      "title1": "部门",
      "title2": "接单日期",
      "title3": "工厂",
      "title4": "开票日期",
      "title5": "材质"
    },
    "thTitle": {
      "title1": "客户代码",
      "title2": "客户名称",
      "title3": "VP",
      "title4": "销售名称",
      "title5": "销售部门",
      "title6": "品牌"
    },
    "tips1": "接单开始日期不能大于结束日期",
    "tips2": "开票开始日期不能大于结束日期",
    "tips3": "接单只能导出半年内数据",
    "tips4": "开票只能导出半年内数据",
    "tips5": "装柜材积必须在2000ft³-2350ft³之内",
    "tips6": "装柜材积必须在56.63m³-66.54m³之内",
    "tips7": "订单中同一款式存在多个颜色，请注意！",
    "tips8": "不可发送"
  },
  "resetPassword": {
    "confirmReset": "确认重置密码？",
    "pleaseEnterUsername": "请输入用户名",
    "reset": "重置",
    "resetSuccess": "重置成功",
    "tip": "提示",
    "username": "用户名",
    "tips": "确定要重置 \"{t}\" 的密码吗"
  },
  "saleBudget": {
    "Account": "科目",
    "apaSalesBudget": "亚太澳销售预算",
    "year": "年份",
    "yearPlaceholder": "选择年份",
    "Baddress": "地址",
    "CDR": "客户折扣率",
    "CDRD": "客户折扣率明细",
    "Tariff": "关税",
    "VPdiscountRate": "VP折扣率",
    "ae": "异常费用",
    "bac": "银行账户",
    "bbi": "敏华收款银行信息",
    "bc": "买家名称",
    "bi": "买家信息",
    "bn": "银行名称",
    "budgetLabel": "预算",
    "budgetQuota": "",
    "budgetYear": "",
    "bv": "生意额",
    "cas": "客户年度销售额",
    "cass": "沙发销售额",
    "cfab": "预约联系人",
    "cfo": "财务负责人",
    "ci": "客户基本信息",
    "clci": "客户后勤联系方式",
    "cpu": "成交价 ",
    "crsim": "全年零售销售额",
    "customerCode": "客户编码",
    "customerName": "客户名称",
    "customerType": "客户类型",
    "dcn": "公司贸易名称",
    "de": "本部费用",
    "dr": "折扣率",
    "fr": "免费补件",
    "fsp": "FOB标准价",
    "fti": "注册税号",
    "mfs": "主要沙发供应商",
    "month": "月份",
    "monthMap": {
      "10": "10月",
      "11": "11月",
      "12": "12月",
      "01": "1月",
      "02": "2月",
      "03": "3月",
      "04": "4月",
      "05": "5月",
      "06": "6月",
      "07": "7月",
      "08": "8月",
      "09": "9月"
    },
    "nbv": "净生意额",
    "nolp": "法人名称",
    "oftf": "海运费+卡车费",
    "osic": "客户驻厂QC",
    "project": "项目",
    "qc": "品质管控联系人",
    "salesAmount": "出货金额",
    "salesBudget": "销售预算",
    "sta": "公司送货地址",
    "summary": "汇总",
    "tdr": "总折扣率",
    "tm": "差旅费",
    "tnr": "净生意额（扣除差旅费（USD)",
    "usaCountry": "国家/州",
    "vpSales": "VP/Sales",
    "wm": "仓库经理",
    "yoyGrowth": "同比增长",
    "ysbr": "年预算达成率",
    "ysdrRate": "预算同比增长"
  },
  "timeOptions": {
    "endPlaceholder": "结束日期",
    "oneMonthAgo": "一个月前",
    "sixMonthAgo": "半年前",
    "startPlaceholder": "开始日期",
    "threeMonthAgo": "三个月前",
    "today": "今天"
  },
  "travel": {
    "TravelSchedule": "出差日程",
    "agree": "通过",
    "approval": "审批",
    "approvalComments": "审批意见",
    "approvalDataExists": "存在审批数据",
    "approvalList": "审批列表",
    "approvalProcessPlanning": "计划审批流程",
    "approvalStatus": "审核状态",
    "approved": "审批通过",
    "approverComments": "负责人审批意见",
    "businessCard": "拜访名片",
    "company": "竞品公司",
    "competitorStyle": "竞品款式",
    "competitors": "竞品",
    "country": "国家/地区",
    "customerDetail": "客户详情介绍",
    "customerName": "客户名",
    "customerType": "客户类型",
    "date": "日期",
    "detail": "明细",
    "exportReport": "导出报告",
    "face": "当面拜访",
    "followUp": "待跟进事项",
    "fullAddress": "详细地址",
    "generalManagerApproval": "总经理审批意见",
    "img": "出差图片",
    "location": "地点",
    "month": "月",
    "mwStyle": "MW款式数",
    "new": "新客户",
    "old": "老客户",
    "nopwaoabt": "正在出差人数",
    "notBeEmpty": "不能为空",
    "orders": "订单",
    "other": "其他",
    "payment": "收款",
    "pendingApproval": "待审批",
    "pendingReview": "待审核",
    "pendingSubmission": "待提交",
    "placementNum": "竞品摆场数",
    "prospectVisitTargets": "拜访意向客户数",
    "ptnopt": "计划出差人数",
    "quality": "品质",
    "recall": "撤回",
    "reject": "驳回上一级",
    "reject1": "驳回给业务",
    "rejected": "已驳回",
    "remark": "备注",
    "retailPrice": "参考零售价",
    "reviewComments": "审核意见",
    "scheduledEndTime": "计划结束时间",
    "scheduledStartTime": "计划开始时间",
    "shipping": "交货",
    "shop": "到店拜访",
    "state": "州",
    "storeNum": "门店数",
    "storeStyle": "款式数",
    "submitForApproval": "提交审批",
    "tDays": "出差天数",
    "tel": "电话拜访",
    "tips": "请选择至少一位 VP/Sales!",
    "tips1": "请选择同一VP/Sales!",
    "title": "出差",
    "tnop": "总人数",
    "tnopwhnt": "未出差人数",
    "travelName": "出差人",
    "travelPlan": "出差计划",
    "travelVPAssistant": "出差VP助理",
    "travelVPSales": "出差VP/Sales",
    "tvn": "拜访客户数",
    "view": "查看",
    "viewCompetitor": "查看全部竞品信息",
    "visitCustomer": "拜访客户",
    "visitMode": "拜访方式",
    "visitResult": "拜访结果",
    "visitResults": "出差反馈",
    "visitTime": "访问时间",
    "vpAssistant": "VP助理",
    "year": "年"
  },
  "x": "老客户",
  "types": "类型",
  "uploadDocuments": "上传文档",
  "util": {
    "CopySuccess": "复制成功",
    "ImageAddedtoEmail": "图片已添加到电子邮件",
    "ImageAlreadyInEmail": "图片已在电子邮件中",
    "disableEmail": "不允许发送邮件",
    "disableSap": "不允许发送 SAP"
  },
  "lineup": {
    "template": "导出预算模板"
  },
  "modelDetail": {
    "pd": "产品描述"
  },
  "ex": {
    "businessCard": "名片",
    "attachment": "附件"
  },
  "qs": {
    "cs": "组合规格"
  },
  "commitments": {
    "detailInfo": "意向订单明细信息",
    "exportOrderUpdateInfo": "导出意向订单更新信息",
    "summaryInfo": "意向订单汇总信息"
  },
  "tips": {
    "resp1": "文件格式错误：仅支持上传 .pptx 格式的文件！"
  },
  "export": {
    "labelType": "导出业务交期分析",
    "labelTypes": "导出客户交期分析"
  },
  "qsReport": {
    "customerCode": "客户代码",
    "customerName": "客户名称",
    "intake": "接单",
    "shipment": "出货",
    "yoyI": "接单同比增长",
    "yoyS": "出货同比增长",
    "IS": "本月接单/出货",
    "TIS": "累计接单/出货"
  },
  "salesAnalysis": {
    "model": "款式",
    "floor": "摆场数",
    "color": "颜色",
    "catagory": "类别",
    "pb": "皮/布",
    "xse": "本月销售额",
    "orderInTakeNum": "本月接单数",
    "threeMonths": "未来三个月接单数",
    "growth": "同比增长",
    "Accumulated": "累计销售净额"
  }
};
